import { render, staticRenderFns } from "./PhdProposal.vue?vue&type=template&id=b1fa8502&"
import script from "./PhdProposal.vue?vue&type=script&lang=js&"
export * from "./PhdProposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports